import { useContext } from "react";
import { Grid2 as Grid, Typography, Stack } from "@mui/material";
import { AppContext } from "../App";
import { TextButton } from "../components/TextButton";

const GENDERS = ["Man", "Woman", "Non-Binary/Non-Conforming"];

export function ProviderGender() {
  const { form, updateForm } = useContext(AppContext);

  const handleSubmit = (value: string) => {
    updateForm({ providerGender: value });
  };

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" gutterBottom>
        My provider's gender must be:
      </Typography>
      <Grid container spacing={2} columns={{ xs: 1, sm: 2, lg: 3 }} alignItems="center" justifyContent="center">
        {GENDERS.map((value: string) => (
          <Grid size={1} key={value}>
            <TextButton selected={form.providerGender === value} onClick={() => handleSubmit(value)} label={value} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
